var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"support-footer",attrs:{"to":"merchant.support@tamara.co"}},[_c('svg-icon',{attrs:{"name":"email","width":"16px","height":"16px"}}),_c('span',{staticClass:"tamara-english-regular-4"},[_vm._v("merchant.support@tamara.co")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }